export const LOADING_STATUS = "LOADING_STATUS";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";

// TOAST_MSG
export const EMPTY_TOAST_MSG = "EMPTY_TOAST_MSG";
export const TOAST_MSG = "TOAST_MSG";
export const HIDE_TOAST_MSG = "HIDE_TOAST_MSG";
export const SHOW_NOTIFICATION_WITH_TIMEOUT = "SHOW_NOTIFICATION_WITH_TIMEOUT";
export const ALERT_MSG = "ALERT_MSG";
export const EMPTY_ALERT_MSG = "EMPTY_ALERT_MSG";

// Auth
export const GET_REGISTER_DETAILS = "GET_REGISTER_DETAILS";
export const GET_REGISTER_DETAILS_FAILED = "GET_REGISTER_DETAILS_FAILED";
export const GET_REGISTER_DETAILS_SUCCEEDED = "GET_REGISTER_DETAILS_SUCCEEDED";
export const SAVE_REGISTER_DETAILS = "SAVE_REGISTER_DETAILS";
export const SAVE_REGISTER_DETAILS_FAILED = "SAVE_REGISTER_DETAILS_FAILED";
export const SAVE_REGISTER_DETAILS_SUCCEEDED =
  "SAVE_REGISTER_DETAILS_SUCCEEDED";
export const SAVE_LOGIN_DETAILS = "SAVE_LOGIN_DETAILS";
export const SAVE_LOGIN_DETAILS_FAILED = "SAVE_LOGIN_DETAILS_FAILED";
export const SAVE_LOGIN_DETAILS_SUCCEEDED = "SAVE_LOGIN_DETAILS_SUCCEEDED";
export const USER_ACTIVATION = "USER_ACTIVATION";
export const USER_ACTIVATION_FAILED = "USER_ACTIVATION_FAILED";
export const USER_ACTIVATION_SUCCEEDED = "USER_ACTIVATION_SUCCEEDED";
export const SAVE_FORGOT_DETAILS = "SAVE_FORGOT_DETAILS";
export const SAVE_FORGOT_DETAILS_FAILED = "SAVE_FORGOT_DETAILS_FAILED";
export const SAVE_FORGOT_DETAILS_SUCCEEDED = "SAVE_FORGOT_DETAILS_SUCCEEDED";
export const CHANGE_IS_REGISTERED = "CHANGE_IS_REGISTERED";
export const INITIAL_REGISTER_DETAILS = "INITIAL_REGISTER_DETAILS";
export const USER_LOGOUT = "USER_LOGOUT";

// Account
export const GET_SECERUITY_QUE = "GET_SECERUITY_QUE";
export const GET_SECERUITY_QUE_FAILED = "GET_SECERUITY_QUE_FAILED";
export const GET_SECERUITY_QUE_SUCCEEDED = "GET_SECERUITY_QUE_SUCCEEDED";
export const SAVE_PROFILE_DETAILS = "SAVE_PROFILE_DETAILS";
export const SAVE_PROFILE_DETAILS_FAILED = "SAVE_PROFILE_DETAILS_FAILED";
export const SAVE_PROFILE_DETAILS_SUCCEEDED = "SAVE_PROFILE_DETAILS_SUCCEEDED";
export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const GET_PROFILE_DETAILS_FAILED = "GET_PROFILE_DETAILS_FAILED";
export const GET_PROFILE_DETAILS_SUCCEEDED = "GET_PROFILE_DETAILS_SUCCEEDED";
export const CHANGE_PASSWORD_DETAILS = "CHANGE_PASSWORD_DETAILS";
export const CHANGE_PASSWORD_DETAILS_FAILED = "CHANGE_PASSWORD_DETAILS_FAILED";

// SetupWizard
export const GET_STARTED_DETAILS = "GET_STARTED_DETAILS";
export const GET_STARTED_DETAILS_FAILED = "GET_STARTED_DETAILS_FAILED";
export const GET_STARTED_DETAILS_SUCCEEDED = "GET_STARTED_DETAILS_SUCCEEDED";
export const GET_SETUP_DETAILS = "GET_SETUP_DETAILS";
export const GET_SETUP_DETAILS_FAILED = "GET_SETUP_DETAILS_FAILED";
export const GET_SETUP_DETAILS_SUCCEEDED = "GET_SETUP_DETAILS_SUCCEEDED";
export const SAVE_REQUEST_API = "SAVE_REQUEST_API";
export const SAVE_REQUEST_API_FAILED = "SAVE_REQUEST_API_FAILED";
export const SAVE_REQUEST_API_SUCCEEDED = "SAVE_REQUEST_API_SUCCEEDED";
export const SAVE_SETUP_WIZARD_FORM = "SAVE_SETUP_WIZARD_FORM";
export const SAVE_SETUP_WIZARD_FORM_FAILED = "SAVE_SETUP_WIZARD_FORM_FAILED";
export const SAVE_SETUP_WIZARD_FORM_SUCCEEDED =
  "SAVE_SETUP_WIZARD_FORM_SUCCEEDED";
export const CHECK_TAX_YEAR = "CHECK_TAX_YEAR";
export const CHECK_TAX_YEAR_FAILED = "CHECK_TAX_YEAR_FAILED";
export const CHECK_TAX_YEAR_SUCCEEDED = "CHECK_TAX_YEAR_SUCCEEDED";
export const GET_TAX_END_DATE = "GET_TAX_END_DATE";
export const GET_TAX_END_DATE_FAILED = "GET_TAX_END_DATE_FAILED";
export const GET_TAX_END_DATE_SUCCEEDED = "GET_TAX_END_DATE_SUCCEEDED";
export const SAVE_ACCOUNTING_PERIOD = "SAVE_ACCOUNTING_PERIOD";
export const SAVE_PAYROLL_FREQ = "SAVE_PAYROLL_FREQ";
export const GET_ACCRUAL_TYPE = "GET_ACCRUAL_TYPE";
export const GET_ACCRUAL_TYPE_FAILED = "GET_ACCRUAL_TYPE_FAILED";
export const GET_ACCRUAL_TYPE_SUCCEEDED = "GET_ACCRUAL_TYPE_SUCCEEDED";
export const SAVE_LABOR_RULE = "SAVE_LABOR_RULE";
export const DELETE_LABOR_RULE = "DELETE_LABOR_RULE";
export const SAVE_UPLOAD_STAFF = "SAVE_UPLOAD_STAFF";
export const SAVE_UPLOAD_STAFF_FAILED = "SAVE_UPLOAD_STAFF_FAILED";
export const SAVE_UPLOAD_STAFF_SUCCEEDED = "SAVE_UPLOAD_STAFF_SUCCEEDED";
export const REMOVE_UPLOAD_STAFF = "REMOVE_UPLOAD_STAFF";
export const DOWNLOAD_STAFF_TEMP = "DOWNLOAD_STAFF_TEMP";
export const SAVE_UPLOAD_PAYEE = "SAVE_UPLOAD_PAYEE";
export const SAVE_UPLOAD_PAYEE_FAILED = "SAVE_UPLOAD_PAYEE_FAILED";
export const SAVE_UPLOAD_PAYEE_SUCCEEDED = "SAVE_UPLOAD_PAYEE_SUCCEEDED";
export const REMOVE_UPLOAD_PAYEE = "REMOVE_UPLOAD_PAYEE";
export const DOWNLOAD_PAYEE_TEMP = "DOWNLOAD_PAYEE_TEMP";
export const BACK_BTN_HANDLER = "BACK_BTN_HANDLER";

export const APPLY_PROMO_WIZARD = "APPLY_PROMO_WIZARD";
export const REMOVE_PROMO_WIZARD = "REMOVE_PROMO_WIZARD";
export const APPLY_PROMO_WIZARD_FAILED = "APPLY_PROMO_WIZARD_FAILED";
export const APPLY_PROMO_WIZARD_SUCCEEDED = "APPLY_PROMO_WIZARD_SUCCEEDED";

export const SAVE_GETTING_STARTED = "SAVE_GETTING_STARTED";
export const SAVE_GETTING_STARTED_FAILED = "SAVE_GETTING_STARTED_FAILED";
export const SAVE_GETTING_STARTED_SUCCEEDED = "SAVE_GETTING_STARTED_SUCCEEDED";

export const GET_STATE = "GET_STATE";
export const GET_STATE_FAILED = "GET_STATE_FAILED";
export const GET_STATE_SUCCEEDED = "GET_STATE_SUCCEEDED";

// Setting
export const SETTING_VALUE_CHANGE = "SETTING_VALUE_CHANGE";
export const SETTING_START_LOADING = "SETTING_START_LOADING";
export const SETTING_STOP_LOADING = "SETTING_STOP_LOADING";
export const SETTING_MODAL_START_LOADING = "SETTING_MODAL_START_LOADING";
export const SETTING_MODAL_STOP_LOADING = "SETTING_MODAL_STOP_LOADING";
export const SETTING_COMPANY_NAME_MODAL_SHOW =
  "SETTING_COMPANY_NAME_MODAL_SHOW";
export const SETTING_COMPANY_NAME_MODAL_HIDE =
  "SETTING_COMPANY_NAME_MODAL_HIDE";
export const SETTING_DOC_MODAL_SHOW = "SETTING_DOC_MODAL_SHOW";
export const SETTING_DOC_MODAL_HIDE = "SETTING_DOC_MODAL_HIDE";
export const SETTING_ACCOUNTING_MODAL_SHOW = "SETTING_ACCOUNTING_MODAL_SHOW";
export const SETTING_ACCOUNTING_MODAL_HIDE = "SETTING_ACCOUNTING_MODAL_HIDE";
export const ACCOUNT_SETTING_INITIAL_STATE = "ACCOUNT_SETTING_INITIAL_STATE";
export const ACCOUNT_SETTING_DETAILS = "ACCOUNT_SETTING_DETAILS";
export const ACCOUNT_SETTING_DETAILS_FAILED = "ACCOUNT_SETTING_DETAILS_FAILED";
export const ACCOUNT_SETTING_DETAILS_SUCCEEDED =
  "ACCOUNT_SETTING_DETAILS_SUCCEEDED";
export const UPLOAD_ACC_LOGO = "UPLOAD_ACC_LOGO";
export const COMPANY_SETTING_DETAILS = "COMPANY_SETTING_DETAILS";
export const COMPANY_SETTING_DETAILS_FAILED = "COMPANY_SETTING_DETAILS_FAILED";
export const COMPANY_SETTING_DETAILS_SUCCEEDED =
  "COMPANY_SETTING_DETAILS_SUCCEEDED";
export const UPLOAD_ACC_DOCUMENT = "UPLOAD_ACC_DOCUMENT";
export const DELETE_ACC_DOCUMENT = "DELETE_ACC_DOCUMENT";
export const UPDATE_POSTING_PERIOD_STATUS = "UPDATE_POSTING_PERIOD_STATUS";
export const GET_COMPANY_NAME = "GET_COMPANY_NAME";
export const SCHEDULE_COMPANY_NAME = "SCHEDULE_COMPANY_NAME";
export const CODE_LIST_DETAILS = "CODE_LIST_DETAILS";
export const CODE_LIST_DETAILS_SUCCEEDED = "CODE_LIST_DETAILS_SUCCEEDED";
export const CODE_LIST_DETAILS_FAILED = "CODE_LIST_DETAILS_FAILED";
export const ADD_CODE_DETAILS = "ADD_CODE_DETAILS";
export const DELETE_CODE_DETAILS = "DELETE_CODE_DETAILS";
export const ACCOUNT_MANAGEMENT_DETAILS = "ACCOUNT_MANAGEMENT_DETAILS";
export const ACCOUNT_MANAGEMENT_DETAILS_FAILED =
  "ACCOUNT_MANAGEMENT_DETAILS_FAILED";
export const ACCOUNT_MANAGEMENT_DETAILS_SUCCEEDED =
  "ACCOUNT_MANAGEMENT_DETAILS_SUCCEEDED";
export const SAVE_ACCOUNT_MANAGEMENT_DETAILS =
  "SAVE_ACCOUNT_MANAGEMENT_DETAILS";
export const UPDATE_ACCOUNT_ADMIN = "UPDATE_ACCOUNT_ADMIN";
export const UPDATE_PLAN_COST = "UPDATE_PLAN_COST";
export const UPDATE_PLAN_TOPUP = "UPDATE_PLAN_TOPUP";
export const UPDATE_POS_COUNT = "UPDATE_POS_COUNT";
export const GET_OWNER_SUBACC = "GET_OWNER_SUBACC";
export const SAVE_PAYMENT_INFO = "SAVE_PAYMENT_INFO";
export const CANCEL_ACCOUNT = "CANCEL_ACCOUNT";
export const GET_INVOICE_LIST = "GET_INVOICE_LIST";
export const GET_INVOICE_LIST_SUCCEEDED = "GET_INVOICE_LIST_SUCCEEDED";
export const GET_INVOICE_LIST_FAILED = "GET_INVOICE_LIST_FAILED";
export const GET_INVOICE_DETAILS = "GET_INVOICE_DETAILS";
// setting - user management
export const GET_USER_MANAGE_DETAILS = "GET_USER_MANAGE_DETAILS";
export const GET_USER_MANAGE_DETAILS_SUCCEEDED =
  "GET_USER_MANAGE_DETAILS_SUCCEEDED";
export const GET_USER_MANAGE_DETAILS_FAILED = "GET_USER_MANAGE_DETAILS_FAILED";
export const GET_MERCHANT_USER_LIST = "GET_MERCHANT_USER_LIST";
export const UPDATE_USER_MANAGE_DETAILS = "UPDATE_USER_MANAGE_DETAILS";
export const ADD_LINKED_EMP = "ADD_LINKED_EMP";
export const GET_PERMISSION_GROUP_LIST = "GET_PERMISSION_GROUP_LIST";
// setting - cluster _DATA = '_DATA'

export const GET_CLUSTER_SETTINGS = "GET_CLUSTER_SETTINGS";
export const GET_CLUSTER_SETTINGS_SUCCEEDED = "GET_CLUSTER_SETTINGS_SUCCEEDED";
export const GET_CLUSTER_SETTINGS_FAILED = "GET_CLUSTER_SETTINGS_FAILED";
export const ADD_CLUSTER_DETAILS = "ADD_CLUSTER_DETAILS";
export const SAVE_CLUSTER_DETAILS = "SAVE_CLUSTER_DETAILS";
export const GET_CLUSTER_MODULES = "GET_CLUSTER_MODULES";
export const ADD_CLUSTER_ACCESS = "ADD_CLUSTER_ACCESS";
export const ADD_CLUSTER_STORE = "ADD_CLUSTER_STORE";

/* finance - settings */

export const SAVE_FINANCE_VALUES = "SAVE_FINANCE_VALUES";

// general settings
export const GET_FINANCE_GENERAL_SETTINGS = "GET_FINANCE_GENERAL_SETTINGS";
export const SAVE_FINANCE_GENERAL_SETTINGS = "SAVE_FINANCE_GENERAL_SETTINGS";
export const GET_FINANCE_SALE_SETTINGS = "GET_FINANCE_SALE_SETTINGS";
export const GET_GROUP_ACC_LIST = "GET_GROUP_ACC_LIST";
export const SAVE_PAYMENT_METHOD = "SAVE_PAYMENT_METHOD";
export const UPDATE_PAYMENT_METHOD_ORDER = "UPDATE_PAYMENT_METHOD_ORDER";
export const DELETE_PAYMENT_METHOD_ORDER = "DELETE_PAYMENT_METHOD_ORDER";
export const SAVE_SERVICE_PERIOD = "SAVE_SERVICE_PERIOD";
export const DELETE_SERVICE_PERIOD = "DELETE_SERVICE_PERIOD";
export const SAVE_SALE_TYPE = "SAVE_SALE_TYPE";
export const DELETE_SALE_TYPE = "DELETE_SALE_TYPE";
export const SAVE_SALE_GROUP = "SAVE_SALE_GROUP";
export const DELETE_SALE_GROUP = "DELETE_SALE_GROUP";
export const SAVE_CHANNEL = "SAVE_CHANNEL";
export const DELETE_CHANNEL = "DELETE_CHANNEL";
export const GET_PUBLIC_HOLIDAY = "GET_PUBLIC_HOLIDAY";
export const SAVE_PUBLIC_HOLIDAY = "SAVE_PUBLIC_HOLIDAY";
export const DELETE_PUBLIC_HOLIDAY = "DELETE_PUBLIC_HOLIDAY";
export const UPDATE_MATRIX_FINANCE = "UPDATE_MATRIX_FINANCE";
export const GET_MASTER_SETTING = "GET_MASTER_SETTING";
export const SAVE_PM_MASTER_SETTING = "SAVE_PM_MASTER_SETTING";
export const UPDATE_PM_MASTER_SETTING = "UPDATE_PM_MASTER_SETTING";
export const UPDATE_PM_MASTER_SETTING_STATUS =
  "UPDATE_PM_MASTER_SETTING_STATUS";
export const REFRESH_PM_MASTER_SETTING = "REFRESH_PM_MASTER_SETTING";
export const SAVE_SALES_MASTER_SETTING = "SAVE_SALES_MASTER_SETTING";
export const UPDATE_SALES_MASTER_SETTING = "UPDATE_SALES_MASTER_SETTING";
export const UPDATE_SALES_MASTER_SETTING_STATUS =
  "UPDATE_SALES_MASTER_SETTING_STATUS";
export const REFRESH_SALES_MASTER_SETTING = "REFRESH_SALES_MASTER_SETTING";
export const SAVE_SERVICE_PERIOD_MASTER_SETTING =
  "SAVE_SERVICE_PERIOD_MASTER_SETTING";
export const UPDATE_SERVICE_PERIOD_MASTER_SETTING =
  "UPDATE_SERVICE_PERIOD_MASTER_SETTING";
export const UPDATE_SERVICE_PERIOD_MASTER_SETTING_STATUS =
  "UPDATE_SERVICE_PERIOD_MASTER_SETTING_STATUS";
export const REFRESH_SERVICE_PERIOD_MASTER_SETTING =
  "REFRESH_SERVICE_PERIOD_MASTER_SETTING";
export const SAVE_CHANNELS_MASTER_SETTING = "SAVE_CHANNELS_MASTER_SETTING";
export const UPDATE_CHANNELS_MASTER_SETTING = "UPDATE_CHANNELS_MASTER_SETTING";
export const UPDATE_CHANNELS_MASTER_SETTING_STATUS =
  "UPDATE_CHANNELS_MASTER_SETTING_STATUS";
export const REFRESH_CHANNELS_MASTER_SETTING =
  "REFRESH_CHANNELS_MASTER_SETTING";
// chart of accounts
export const GET_FINANCE_CHARTS_OF_ACC_SETTINGS =
  "GET_FINANCE_CHARTS_OF_ACC_SETTINGS";
export const GET_FINANCE_ACCOUNTS = "GET_FINANCE_ACCOUNTS";
export const DOWNLOAD_ALL_FINANCE_ACCOUNTS = "DOWNLOAD_ALL_FINANCE_ACCOUNTS";
export const ADD_FINANCE_ACCOUNTS = "ADD_FINANCE_ACCOUNTS";
export const ADD_FINANCE_SUB_ACCOUNTS = "ADD_FINANCE_SUB_ACCOUNTS";
export const SAVE_FINANCE_SUB_ACCOUNTS = "SAVE_FINANCE_SUB_ACCOUNTS";
export const GET_UPDATE_FINANCE_SUB_ACCOUNTS =
  "GET_UPDATE_FINANCE_SUB_ACCOUNTS";
export const GET_SUB_ACCOUNT_TRANSACTIONS = "GET_SUB_ACCOUNT_TRANSACTIONS";
export const SAVE_EDIT_SUB_ACCOUNT = "SAVE_EDIT_SUB_ACCOUNT";
export const GET_ADD_TRANS_SUB_ACCOUNTS = "GET_ADD_TRANS_SUB_ACCOUNTS";
export const GET_DEBIT_CREDIT_ACCOUNT = "GET_DEBIT_CREDIT_ACCOUNT";
export const SAVE_ACCOUNT_TRANSACTION = "SAVE_ACCOUNT_TRANSACTION";

// Forecast
export const GET_FINANCE_FORECAST_SETTINGS = "GET_FINANCE_FORECAST_SETTINGS";
export const GET_FORECAST_RULE = "GET_FORECAST_RULE";
export const GET_APPLICABLE_QUARTER = "GET_APPLICABLE_QUARTER";
export const SAVE_FINANCE_FORECAST_SETTINGS = "SAVE_FINANCE_FORECAST_SETTINGS";
export const EDIT_FINANCE_RULE = "EDIT_FINANCE_RULE";
export const UPDATE_FINANCE_RULE = "UPDATE_FINANCE_RULE";

// Reconcile
export const GET_RECONSILE_SETTINGS = "GET_RECONSILE_SETTINGS";
export const ADD_RECONSILE_SETTINGS = "ADD_RECONSILE_SETTINGS";
export const DELETE_RECONSILE_SETTINGS = "DELETE_RECONSILE_SETTINGS";
export const GET_RECONSILE_UPLOAD_SETTINGS = "GET_RECONSILE_UPLOAD_SETTINGS";
export const SAVE_RECONSILE_UPLOAD_SETTINGS = "SAVE_RECONSILE_UPLOAD_SETTINGS";

// order setting action
export const GET_ORDER_SETTINGS = "GET_ORDER_SETTINGS";
export const SAVE_ORDER_SETTINGS = "SAVE_ORDER_SETTINGS";
export const POST_ORDER_SETTINGS = "POST_ORDER_SETTINGS";

export const GET_ORDER_TRANSFER_DATA = "GET_ORDER_TRANSFER_DATA";
export const SAVE_ORDER_TRANSFER_DATA = "SAVE_ORDER_TRANSFER_DATA";
export const POST_ORDER_TRANSFER_DATA = "POST_ORDER_TRANSFER_DATA";

export const GET_SECOND_ACCOUNTS = "GET_SECOND_ACCOUNTS";
export const SAVE_ORDER_TRANSFER_SECONDARY_ACCOUNT =
  "SAVE_ORDER_TRANSFER_SECONDARY_ACCOUNT";

export const ADD_TRANSFER_ACCOUNT = "ADD_TRANSFER_ACCOUNT";

export const GET_TRANSFER_ACCOUNT_EDIT_DETAILS =
  "GET_TRANSFER_ACCOUNT_EDIT_DETAILS";
export const SAVE_TRANSFER_ACCOUNT_EDIT_DETAILS =
  "SAVE_TRANSFER_ACCOUNT_EDIT_DETAILS";
export const EDIT_TRANSFER_ACCOUNT = "EDIT_TRANSFER_ACCOUNT";

export const UPDATE_TRANSFER_ACCOUNT_STATUS = "UPDATE_TRANSFER_ACCOUNT_STATUS";

// onlife action
export const GET_ON_LIFE_DATA = "GET_ON_LIFE_DATA";
export const SAVE_ON_LIFE_DATA = "SAVE_ON_LIFE_DATA";

export const POST_MERCHANT_ON_LIFE_DATA = "POST_MERCHANT_ON_LIFE_DATA";

/* Menu Engineer */
export const MENU_INITIAL_VALUE = "MENU_INITIAL_VALUE";
export const MENU_VALUE_CHANGE = "MENU_VALUE_CHANGE";
export const GET_MENU_INGREDIENTS = "GET_MENU_INGREDIENTS";
export const ADD_MENU_INGREDIENT_DETAILS = "ADD_MENU_INGREDIENT_DETAILS";
export const SAVE_MENU_INGREDIENT_DETAILS = "SAVE_MENU_INGREDIENT_DETAILS";
export const CHECK_SUPPLIER_DETAILS = "CHECK_SUPPLIER_DETAILS";
export const SAVE_STORAGE_AREA_DETAILS = "SAVE_STORAGE_AREA_DETAILS";
export const SAVE_MENU_STORAGE_AREA_DETAILS = "SAVE_MENU_STORAGE_AREA_DETAILS";
export const POST_COMPETITOR_ON_LIFE_DATA = "POST_COMPETITOR_ON_LIFE_DATA";
export const DELETE_COMPETITOR_ON_LIFE_DATA = "DELETE_COMPETITOR_ON_LIFE_DATA";
export const GET_CONVERSION_MULTIPLIER = "GET_CONVERSION_MULTIPLIER";
export const GET_INVENTORY_UOM = "GET_INVENTORY_UOM";
export const SAVE_BACKUP_INGREDIENT = "SAVE_BACKUP_INGREDIENT";
export const GET_BACKUP_INGREDIENT = "GET_BACKUP_INGREDIENT";
export const GET_EDIT_INGREDIENT = "GET_EDIT_INGREDIENT";
export const GET_INGRE_MENU_APPROVAL = "GET_INGRE_MENU_APPROVAL";
export const CHANGE_PEND_INGREDIENT_STATUS = "CHANGE_PEND_INGREDIENT_STATUS";
export const CHANGE_INGREDIENT_STATUS = "CHANGE_INGREDIENT_STATUS";
export const GET_MENU_RECIPE = "GET_MENU_RECIPE";
export const ADD_MENU_RECIPE_DETAILS = "ADD_MENU_RECIPE_DETAILS";
export const SAVE_MENU_RECIPE_DETAILS = "SAVE_MENU_RECIPE_DETAILS";
export const GET_MEASUREMENT_UNIT = "GET_MEASUREMENT_UNIT";
export const GET_RECIPE_COST_PRICE = "GET_RECIPE_COST_PRICE";
export const GET_RECIPE_MULTIPLIER = "GET_RECIPE_MULTIPLIER";
export const GET_RECIPE_UNIT_PRICE = "GET_RECIPE_UNIT_PRICE";
export const GET_EDIT_RECIPE = "GET_EDIT_RECIPE";
export const CHANGE_PEND_RECIPE_STATUS = "CHANGE_PEND_RECIPE_STATUS";
export const GET_MENU_ITEMS = "GET_MENU_ITEMS";
export const GET_MENU_ITEM_SUB_CLASS = "GET_MENU_ITEM_SUB_CLASS";
export const GET_MENU_ITEM_SUB_CATEGORY = "GET_MENU_ITEM_SUB_CATEGORY";
export const UPDATE_MENU_ITEM_CLASS = "UPDATE_MENU_ITEM_CLASS";
export const UPDATE_MENU_ITEM_CATEGORY = "UPDATE_MENU_ITEM_CATEGORY";
export const UPDATE_MENU_ITEM_STATUS = "UPDATE_MENU_ITEM_STATUS";
export const EDIT_MENU_ITEM_LIFESPAN = "EDIT_MENU_ITEM_LIFESPAN";
export const UPDATE_MENU_ITEM_LIFESPAN = "UPDATE_MENU_ITEM_LIFESPAN";
export const GET_ADD_MENU_ITEM = "GET_ADD_MENU_ITEM";
export const GET_EDIT_MENU_ITEM = "GET_EDIT_MENU_ITEM";
export const SAVE_ADD_MENU_ITEM = "SAVE_ADD_MENU_ITEM";
export const GET_MENU_ITEM_CA = "GET_MENU_ITEM_CA";
export const GET_MENU_MEASUREMENT_UNIT = "GET_MENU_MEASUREMENT_UNIT";
export const GET_MENU_UNIT_PRICE = "GET_MENU_UNIT_PRICE";
export const GET_MENU_MULTI_UNIT = "GET_MENU_MULTI_UNIT";
export const GET_ADD_MENU_PRICINGS = "GET_ADD_MENU_PRICINGS";
export const SAVE_ADD_MENU_PRICINGS = "SAVE_ADD_MENU_PRICINGS";
export const GET_EDIT_MENU_PRICINGS = "GET_EDIT_MENU_PRICINGS";
export const DELETE_MENU_PRICINGS = "DELETE_MENU_PRICINGS";
export const DELETE_EDIT_MENU_PRICINGS = "DELETE_EDIT_MENU_PRICINGS";
export const GET_MENU_PRICING_LIST = "GET_MENU_PRICING_LIST";
export const GET_MENU_LIST = "GET_MENU_LIST";
export const GET_COST_PER_ITEM = "GET_COST_PER_ITEM";
export const SAVE_EDIT_MENU_PRICINGS = "SAVE_EDIT_MENU_PRICINGS";
export const GET_MENU_EDIT_PRICINGS = "GET_MENU_EDIT_PRICINGS";
export const GET_EDIT_MENU_PRICING_LIST = "GET_EDIT_MENU_PRICING_LIST";
export const GET_EDIT_MENU_EDIT_PRICINGS = "GET_EDIT_MENU_EDIT_PRICINGS";
// custom modifiers
export const GET_MENU_ITEM_MODIFIERS = "GET_MENU_ITEM_MODIFIERS";
export const GET_COST_PER_MENU_ITEM = "GET_COST_PER_MENU_ITEM";
export const SAVE_MENU_ITEM_MODIFIER = "SAVE_MENU_ITEM_MODIFIER";
export const DELETE_MENU_ITEM_MODIFIER = "DELETE_MENU_ITEM_MODIFIER";
export const DELETE_MENU_BUNDLE_ITEM_MODIFIER =
  "DELETE_MENU_BUNDLE_ITEM_MODIFIER";
export const GET_COPY_BUNDLE_MODIFIER = "GET_COPY_BUNDLE_MODIFIER";
export const GET_BUNDLE_MODIFIER_FOR_COPY = "GET_BUNDLE_MODIFIER_FOR_COPY";
export const SAVE_COPY_BUNDLE_MODIFIER = "SAVE_COPY_BUNDLE_MODIFIER";
export const EDIT_MENU_BUNDLE_ITEM_MODIFIER = "EDIT_MENU_BUNDLE_ITEM_MODIFIER";

// pos master --> pos master
export const GET_POS_MASTER_DATA = "GET_POS_MASTER_DATA";
export const SAVE_POS_MASTER_DATA = "SAVE_POS_MASTER_DATA";

export const GET_POS_MASTER_FORM_OPTIONS = "GET_POS_MASTER_FORM_OPTIONS";
export const SAVE_POS_MASTER_FORM_OPTIONS = "SAVE_POS_MASTER_FORM_OPTIONS";
export const POST_POS_MASTER_ACTIVE_STATUS = "POST_POS_MASTER_ACTIVE_STATUS";

export const GET_EDIT_POS_MASTER_FORM_DATA = "GET_EDIT_POS_MASTER_FORM_DATA";
export const SAVE_EDIT_POS_MASTER_FORM_DATA = "SAVE_EDIT_POS_MASTER_FORM_DATA";
export const POST_EDIT_POS_MASTER_FORM_DATA = "POST_EDIT_POS_MASTER_FORM_DATA";
export const POST_ADD_POS_MASTER_FORM_DATA = "POST_ADD_POS_MASTER_FORM_DATA";

export const POST_POS_INTEGRATION_SETTING = "POST_POS_INTEGRATION_SETTING";
export const SAVE_POS_INTEGRATION_SETTING_DATA =
  "SAVE_POS_INTEGRATION_SETTING_DATA";
export const GET_APPLICABLE_MODULE = "GET_APPLICABLE_MODULE";
export const SAVE_APPLICABLE_MODULE = "SAVE_APPLICABLE_MODULE";
export const GET_FREQUENCY = "GET_FREQUENCY";
export const SAVE_FREQUENCY = "SAVE_FREQUENCY";

//  layout master

export const GET_ROOMS_LAYOUT_DATA = "GET_ROOMS_LAYOUT_DATA";
export const SAVE_ROOMS_LAYOUT_DATA = "SAVE_ROOMS_LAYOUT_DATA";

export const POST_ADD_ROOM_LAYOUT = "POST_ADD_ROOM_LAYOUT";

export const GET_EDIT_ROOM_LAYOUT = "GET_EDIT_ROOM_LAYOUT";
export const SAVE_EDIT_ROOM_LAYOUT = "SAVE_EDIT_ROOM_LAYOUT";
export const POST_EDIT_ROOM_LAYOUT = "POST_EDIT_ROOM_LAYOUT";

export const DELETE_ROOM_LAYOUT = "DELETE_ROOM_LAYOUT";

//  table master

export const GET_TABLE_MASTER_DATA = "GET_TABLE_MASTER_DATA";
export const SAVE_TABLE_MASTER_DATA = "SAVE_TABLE_MASTER_DATA";

export const GET_EDIT_TABLE_MASTER_FORM_DATA =
  "GET_EDIT_TABLE_MASTER_FORM_DATA";
export const SAVE_EDIT_TABLE_MASTER_FORM_DATA =
  "SAVE_EDIT_TABLE_MASTER_FORM_DATA";
export const POST_EDIT_TABLE_MASTER_FORM_DATA =
  "POST_EDIT_TABLE_MASTER_FORM_DATA";

export const POST_ADD_TABLE_MASTER_FORM_DATA =
  "POST_ADD_TABLE_MASTER_FORM_DATA";

export const GET_TABLE_MASTER_FORM_DATA = "GET_TABLE_MASTER_FORM_DATA";
export const SAVE_TABLE_MASTER_FORM_DATA = "SAVE_TABLE_MASTER_FORM_DATA";
export const POST_ADD_ROOM_IN_FORM = "POST_ADD_ROOM_IN_FORM";

//  hardware master
export const GET_HARDWARE_MASTER_DATA = "GET_HARDWARE_MASTER_DATA";
export const SAVE_HARDWARE_MASTER_DATA = "SAVE_HARDWARE_MASTER_DATA";
export const POST_HARDWARE_MASTER_DATA = "POST_HARDWARE_MASTER_DATA";
export const GET_HARDWARE_MASTER_FORM_DATA = "GET_HARDWARE_MASTER_FORM_DATA";
export const SAVE_HARDWARE_MASTER_FORM_DATA = "SAVE_HARDWARE_MASTER_FORM_DATA";

export const SET_HARDWARE_MODEL = "SET_HARDWARE_MODEL";
export const SET_HARDWARE_MAKER = "SET_HARDWARE_MAKER";

export const GET_QUALIFICATION_SELECTION = "GET_QUALIFICATION_SELECTION";
export const SAVE_QUALIFICATION_SELECTION = "SAVE_QUALIFICATION_SELECTION";

export const GET_EDIT_HARDWARE_MASTER_DATA = "GET_EDIT_HARDWARE_MASTER_DATA";
export const SAVE_EDIT_HARDWARE_MASTER_DATA = "SAVE_EDIT_HARDWARE_MASTER_DATA";
export const POST_EDIT_HARDWARE_MASTER_DATA = "POST_EDIT_HARDWARE_MASTER_DATA";

export const GET_HARDWARE_DETAILS_SESSION = "GET_HARDWARE_DETAILS_SESSION";
export const SAVE_HARDWARE_DETAILS_SESSION = "SAVE_HARDWARE_DETAILS_SESSION";
export const POST_HARDWARE_DETAILS_SESSION = "POST_HARDWARE_DETAILS_SESSION";

export const SET_MODAL_STATE = "SET_MODAL_STATE";
export const SET_FORM_STATE = "SET_FORM_STATE";

export const GET_INVENTORY_GENERAL_SETTINGS_DATA =
  "GET_INVENTORY_GENERAL_SETTINGS_DATA";
export const SAVE_INVENTORY_GENERAL_SETTINGS_DATA =
  "SAVE_INVENTORY_GENERAL_SETTINGS_DATA";
export const POST_INVENTORY_GENERAL_SETTINGS_DATA =
  "POST_INVENTORY_GENERAL_SETTINGS_DATA";

export const GET_INVENTORY_COUNT_SETTINGS_DATA =
  "GET_INVENTORY_COUNT_SETTINGS_DATA";
export const SAVE_INVENTORY_COUNT_SETTINGS_DATA =
  "SAVE_INVENTORY_COUNT_SETTINGS_DATA";
export const POST_ADD_INVENTORY_COUNT_SETTINGS_DATA =
  "POST_ADD_INVENTORY_COUNT_SETTINGS_DATA";

export const GET_EDIT_INVENTORY_COUNT_SETTINGS_DATA =
  "GET_EDIT_INVENTORY_COUNT_SETTINGS_DATA";
export const SAVE_EDIT_INVENTORY_COUNT_SETTINGS_DATA =
  "SAVE_EDIT_INVENTORY_COUNT_SETTINGS_DATA";
export const POST_EDIT_INVENTORY_COUNT_SETTINGS_DATA =
  "POST_EDIT_INVENTORY_COUNT_SETTINGS_DATA";

export const DELETE_INVENTORY_COUNT_SETTINGS_DATA =
  "DELETE_INVENTORY_COUNT_SETTINGS_DATA";
export const POST_GENERAL_COUNT_SETTINGS = "POST_GENERAL_COUNT_SETTINGS";

// labour
export const GET_LABOUR_ADD_EMPLOYEE_FORM_DATA =
  "GET_LABOUR_ADD_EMPLOYEE_FORM_DATA";
export const SAVE_LABOUR_ADD_EMPLOYEE_FORM_DATA =
  "SAVE_LABOUR_ADD_EMPLOYEE_FORM_DATA";
export const POST_LABOUR_ADD_EMPLOYEE_FORM_DATA =
  "POST_LABOUR_ADD_EMPLOYEE_FORM_DATA";

export const GET_LABOUR_EMPLOYEE_LIST = "GET_LABOUR_EMPLOYEE_LIST";
export const SAVE_LABOUR_EMPLOYEE_LIST = "SAVE_LABOUR_EMPLOYEE_LIST";

export const GET_EDIT_LABOUR_EMPLOYEE_DATA = "GET_EDIT_LABOUR_EMPLOYEE_DATA";
export const SAVE_EDIT_LABOUR_EMPLOYEE_DATA = "SAVE_EDIT_LABOUR_EMPLOYEE_DATA";
export const POST_EDIT_LABOUR_EMPLOYEE_DATA = "POST_EDIT_LABOUR_EMPLOYEE_DATA";

export const GET_EMPLOYEE_BANKING_INFO = "GET_EMPLOYEE_BANKING_INFO";
export const SAVE_EMPLOYEE_BANKING_INFO = "SAVE_EMPLOYEE_BANKING_INFO";
export const POST_EMPLOYEE_BANKING_INFO = "POST_EMPLOYEE_BANKING_INFO";
export const DELETE_EMPLOYEE_BANKING_INFO = "DELETE_EMPLOYEE_BANKING_INFO";

export const GET_EMPLOYEE_DOCUMENT_INFO = "GET_EMPLOYEE_DOCUMENT_INFO";
export const SAVE_EMPLOYEE_DOCUMENT_INFO = "SAVE_EMPLOYEE_DOCUMENT_INFO";
export const POST_EMPLOYEE_DOCUMENT_INFO = "POST_EMPLOYEE_DOCUMENT_INFO";
export const DELETE_EMPLOYEE_DOCUMENT_INFO = "DELETE_EMPLOYEE_DOCUMENT_INFO";

export const GET_EMPLOYEE_TAX_DOCUMENT_INFO = "GET_EMPLOYEE_TAX_DOCUMENT_INFO";
export const SAVE_EMPLOYEE_TAX_DOCUMENT_INFO =
  "SAVE_EMPLOYEE_TAX_DOCUMENT_INFO";
export const POST_EMPLOYEE_TAX_DOCUMENT_INFO =
  "POST_EMPLOYEE_TAX_DOCUMENT_INFO";
export const DELETE_EMPLOYEE_TAX_DOCUMENT_INFO =
  "DELETE_EMPLOYEE_TAX_DOCUMENT_INFO";

export const GET_EMPLOYEE_DEPENDENTS_INFO = "GET_EMPLOYEE_DEPENDENTS_INFO";
export const SAVE_EMPLOYEE_DEPENDENTS_INFO = "SAVE_EMPLOYEE_DEPENDENTS_INFO";
export const POST_EMPLOYEE_DEPENDENTS_INFO = "POST_EMPLOYEE_DEPENDENTS_INFO";
export const DELETE_EMPLOYEE_DEPENDENTS_INFO =
  "DELETE_EMPLOYEE_DEPENDENTS_INFO";

export const GET_CLIPBOARD_DATA = "GET_CLIPBOARD_DATA";
export const SAVE_CLIPBOARD_DATA = "SAVE_CLIPBOARD_DATA";
export const POST_CLIPBOARD_DATA = "POST_CLIPBOARD_DATA";

export const POST_CLIPBOARD_DESCRIPTION = "POST_CLIPBOARD_DESCRIPTION";
export const DELETE_CLIPBOARD_DESCRIPTION = "DELETE_CLIPBOARD_DESCRIPTION";

export const GET_PROMOTIONS = "GET_PROMOTIONS";
export const SAVE_PROMOTIONS = "SAVE_PROMOTIONS";
export const DELETE_PROMOTION = "DELETE_PROMOTION";

export const GET_PROMOTIONS_FORM_DATA = "GET_PROMOTIONS_FORM_DATA";
export const SAVE_PROMOTIONS_FORM_DATA = "SAVE_PROMOTIONS_FORM_DATA";
export const POST_ADD_PROMOTION_DATA = "POST_ADD_PROMOTION_DATA";

export const POST_PROMOTION_APPLICATION_DATA =
  "POST_PROMOTION_APPLICATION_DATA";
export const SAVE_PROMOTION_APPLICATION_DATA =
  "SAVE_PROMOTION_APPLICATION_DATA";

export const GET_EDIT_PROMOTION_DATA = "GET_EDIT_PROMOTION_DATA";
export const SAVE_EDIT_PROMOTION_DATA = "SAVE_EDIT_PROMOTION_DATA";
export const POST_EDIT_PROMOTION_DATA = "POST_EDIT_PROMOTION_DATA";

export const POST_PROMO_GROUP = "POST_PROMO_GROUP";
export const SAVE_PROMO_GROUP = "SAVE_PROMO_GROUP";

export const EDIT_PROMOTION_PERIOD = "EDIT_PROMOTION_PERIOD";
export const ADD_PROMOTION_PERIOD = "ADD_PROMOTION_PERIOD";
export const GET_ADD_PROMOTION_PERIOD_DATA = "GET_ADD_PROMOTION_PERIOD_DATA";

export const SAVE_PROMOTION_PERIOD = "SAVE_PROMOTION_PERIOD";
export const DELETE_PROMOTION_PERIOD = "DELETE_PROMOTION_PERIOD";
export const GET_QUALIFICATION_CRITERIA = "GET_QUALIFICATION_CRITERIA";
export const SAVE_QUALIFICATION_CRITERIA = "SAVE_QUALIFICATION_CRITERIA";
export const POST_QUALIFICATION_CRITERIA = "POST_QUALIFICATION_CRITERIA";

export const GET_MENU_PRICING_DETAILS = "GET_MENU_PRICING_DETAILS";
export const SAVE_MENU_PRICING_DETAILS = "SAVE_MENU_PRICING_DETAILS";
export const POST_MENU_PRICING_DETAILS = "POST_MENU_PRICING_DETAILS";

export const GET_SCHEDULED_MENU_PRICING_DETAILS =
  "GET_SCHEDULED_MENU_PRICING_DETAILS";
export const SAVE_SCHEDULED_MENU_PRICING_DETAILS =
  "SAVE_SCHEDULED_MENU_PRICING_DETAILS";
export const POST_SCHEDULED_MENU_PRICING_DETAILS =
  "POST_SCHEDULED_MENU_PRICING_DETAILS";
export const DELETE_SCHEDULED_MENU_ITEM = "DELETE_SCHEDULED_MENU_ITEM";

export const SAVE_EDIT_SCHEDULED_MENU_ITEM = "SAVE_EDIT_SCHEDULED_MENU_ITEM";

export const SEARCH_MENU_BY_NAME = "SEARCH_MENU_BY_NAME";
export const SAVE_SEARCH_MENU_RESULT = "SEARCH_MENU_RESULT";

export const GET_SALES_TYPE = "GET_SALES_TYPE";
export const SAVE_SALES_TYPE = "SAVE_SALES_TYPE";

export const GET_QR_ORDER_DATA = "GET_QR_ORDER_DATA";
export const SAVE_QR_ORDER_DATA = "SAVE_QR_ORDER_DATA";
export const POST_QR_ORDER_DATA = "POST_QR_ORDER_DATA";

export const POST_PDF_MENU = "POST_PDF_MENU";
export const EDIT_SAVE_PDF_MENU_DATA = "EDIT_SAVE_PDF_MENU_DATA";
export const EDIT_POST_PDF_MENU_DATA = "EDIT_POST_PDF_MENU_DATA";
export const SAVE_UPDATED_PDF_MENU_DATA = "SAVE_UPDATED_PDF_MENU_DATA";

export const GET_MENU_SEQUENCING_DATA = "GET_MENU_SEQUENCING_DATA";
export const SAVE_MENU_SEQUENCING_DATA = "SAVE_MENU_SEQUENCING_DATA";
export const POST_MENU_SEQUENCING_DATA = "POST_MENU_SEQUENCING_DATA";

export const GET_QR_LIST = "GET_QR_LIST";
export const SAVE_QR_LIST = "SAVE_QR_LIST";

export const DOWNLOAD_QR_LIST = "DOWNLOAD_QR_LIST";
export const DOWNLOAD_SELECTED_QR = "DOWNLOAD_SELECTED_QR";
export const REGENERATE_SELECTED_QR = "REGENERATE_SELECTED_QR";
export const REFRESH_TABLE_QR_CODE = "REFRESH_TABLE_QR_CODE";

export const GET_ORDRR_ONLINE_MENU_SEQUENCING_DATA =
  "GET_ORDRR_ONLINE_MENU_SEQUENCING_DATA";
export const SAVE_ORDRR_ONLINE_MENU_SEQUENCING_DATA =
  "SAVE_ORDRR_ONLINE_MENU_SEQUENCING_DATA";
export const POST_ORDRR_ONLINE_MENU_SEQUENCING_DATA =
  "POST_ORDRR_ONLINE_MENU_SEQUENCING_DATA";

export const GET_ORDRR_ONLINE_DATA = "GET_ORDRR_ONLINE_DATA";
export const SAVE_ORDRR_ONLINE_DATA = "SAVE_ORDRR_ONLINE_DATA";
export const POST_ORDRR_ONLINE_DATA = "POST_ORDRR_ONLINE_DATA";

export const GET_DELIVERY_PARTNER_DATA = "GET_DELIVERY_PARTNER_DATA";
export const SAVE_DELIVERY_PARTNER_DATA = "SAVE_DELIVERY_PARTNER_DATA";
export const POST_DELIVERY_PARTNER_DATA = "POST_DELIVERY_PARTNER_DATA";
export const ADD_DELIVERY_PARTNER = "ADD_DELIVERY_PARTNER";
export const EDIT_DELIVERY_PARTNER = "EDIT_DELIVERY_PARTNER";
export const DELETE_DELIVERY_PARTNER = "DELETE_DELIVERY_PARTNER";

export const GET_API_KEY_LISTING = "GET_API_KEY_LISTING";
export const SAVE_API_KEY_LISTING = "SAVE_API_KEY_LISTING";

export const POST_DELETE_API_KEY = "POST_DELETE_API_KEY";

export const POST_CONFIRM_PASSWORD = "POST_CONFIRM_PASSWORD";
export const SAVE_CONFIRM_PASSWORD_STATUS = "SAVE_CONFIRM_PASSWORD_STATUS";

export const POST_GENERATE_API_KEY = "POST_GENERATE_API_KEY";
export const GET_INTEGRATION_DATA = "GET_INTEGRATION_DATA";
export const SAVE_INTEGRATION_DATA = "SAVE_INTEGRATION_DATA";
export const POST_PACKAGE_STATUS = "POST_PACKAGE_STATUS";
export const GET_INTEGRATION_EDIT_DATA = "GET_INTEGRATION_EDIT_DATA";
export const SAVE_INTEGRATION_EDIT_DATA = "SAVE_INTEGRATION_EDIT_DATA";
export const POST_INTEGRATION_EDIT_DATA = "POST_INTEGRATION_EDIT_DATA";
export const POST_PAUSE_STORE = "POST_PAUSE_STORE";

// sales
export const GET_SALES_DATA = "GET_SALES_DATA";
export const SAVE_SALES_DATA = "SAVE_SALES_DATA";

export const GET_OTHER_INCOME_DATA_OPTIONS = "GET_OTHER_INCOME_DATA_OPTIONS";
export const SAVE_OTHER_INCOME_DATA_OPTIONS = "SAVE_OTHER_INCOME_DATA_OPTIONS";
export const POST_OTHER_INCOME_DATA = "POST_OTHER_INCOME_DATA";
export const SAVE_OTHER_INCOME_DATA = "SAVE_OTHER_INCOME_DATA";

export const SAVE_OTHER_INCOME_EDIT_DATA = "SAVE_OTHER_INCOME_EDIT_DATA";
export const POST_OTHER_INCOME_EDIT_DATA = "POST_OTHER_INCOME_EDIT_DATA";

// order payments
export const GET_ORDER_PAYMENTS_DATA = "GET_ORDER_PAYMENTS_DATA";
export const SAVE_ORDER_PAYMENTS_DATA = "SAVE_ORDER_PAYMENTS_DATA";

export const GET_ORDER_PAYMENTS_ITEM_DATA = "GET_ORDER_PAYMENTS_ITEM_DATA";
export const SAVE_ORDER_PAYMENTS_ITEM_DATA = "SAVE_ORDER_PAYMENTS_ITEM_DATA";

export const GET_ORDER_PAYMENTS_BUNDLE_ITEM_DATA =
  "GET_ORDER_PAYMENTS_BUNDLE_ITEM_DATA";
export const SAVE_ORDER_PAYMENTS_BUNDLE_ITEM_DATA =
  "SAVE_ORDER_PAYMENTS_BUNDLE_ITEM_DATA";

export const GET_ORDER_PAYMENTS_COMPONENT_DATA =
  "GET_ORDER_PAYMENTS_COMPONENT_DATA";
export const SAVE_ORDER_PAYMENTS_COMPONENT_DATA =
  "SAVE_ORDER_PAYMENTS_COMPONENT_DATA";

export const GET_ORDER_PAYMENTS_VIEW_BILLS_DATA =
  "GET_ORDER_PAYMENTS_VIEW_BILLS_DATA";
export const SAVE_ORDER_PAYMENTS_VIEW_BILLS_DATA =
  "SAVE_ORDER_PAYMENTS_VIEW_BILLS_DATA";

export const GET_ORDER_PAYMENTS_BILLS_ITEM_DATA =
  "GET_ORDER_PAYMENTS_BILLS_ITEM_DATA";
export const GET_ORDER_PAYMENTS_BILLS_COMPONENT_DATA =
  "GET_ORDER_PAYMENTS_BILLS_COMPONENT_DATA";

export const POST_ORDER_PAYMENTS_PRINT_BILL = "POST_ORDER_PAYMENTS_PRINT_BILL";

// refunds
export const GET_REFUNDS_DATA = "GET_REFUNDS_DATA";
export const SAVE_REFUNDS_DATA = "SAVE_REFUNDS_DATA";

export const GET_REFUNDS_BILL_DATA = "GET_REFUNDS_BILL_DATA";
export const SAVE_REFUNDS_BILL_DATA = "SAVE_REFUNDS_BILL_DATA";

export const GET_INNER_MENU_ITEMS_DATA = "GET_INNER_MENU_ITEMS_DATA";
export const SAVE_INNER_MENU_ITEMS_DATA = "SAVE_INNER_MENU_ITEMS_DATA";

export const GET_INNER_COMPONENT_DATA = "GET_INNER_COMPONENT_DATA";
export const SAVE_INNER_COMPONENT_DATA = "SAVE_INNER_COMPONENT_DATA";

// voids
export const GET_VOIDS_DATA = "GET_VOIDS_DATA";
export const SAVE_VOIDS_DATA = "SAVE_VOIDS_DATA";

// discounts
export const GET_DISCOUNTS_DATA = "GET_DISCOUNTS_DATA";
export const SAVE_DISCOUNTS_DATA = "SAVE_DISCOUNTS_DATA";

// tips
export const GET_TIPS_DATA = "GET_TIPS_DATA";
export const SAVE_TIPS_DATA = "SAVE_TIPS_DATA";

// promotions
export const GET_PROMOTIONS_DATA = "GET_PROMOTIONS_DATA";
export const SAVE_PROMOTIONS_DATA = "SAVE_PROMOTIONS_DATA";

export const GET_PROMOTIONS_SALES_DATA = "GET_PROMOTIONS_SALES_DATA";
export const SAVE_PROMOTIONS_SALES_DATA = "SAVE_PROMOTIONS_SALES_DATA";

// expenses
export const GET_EXPENSES_DATA = "GET_EXPENSES_DATA";
export const SAVE_EXPENSES_DATA = "SAVE_EXPENSES_DATA";

// payments
export const GET_PAYMENTS_DATA = "GET_PAYMENTS_DATA";
export const SAVE_PAYMENTS_DATA = "SAVE_PAYMENTS_DATA";
export const ADD_PAYMENTS_FORM_DATA = "ADD_PAYMENTS_FORM_DATA";
export const SAVE_ADD_PAYMENTS_FORM_DATA = "SAVE_ADD_PAYMENTS_FORM_DATA";
export const POST_ADD_PAYMENTS_FORM_DATA = "POST_ADD_PAYMENTS_FORM_DATA";

export const GET_EXPENSE_TYPE_DATA = "GET_EXPENSE_TYPE_DATA";
export const SAVE_EXPENSE_TYPE_DATA = "SAVE_EXPENSE_TYPE_DATA";

export const GET_INVOICES_DATA = "GET_INVOICES_DATA";
export const SAVE_INVOICES_DATA = "SAVE_INVOICES_DATA";

export const GET_PAY_TRADE_LIABILITY_DATA = "GET_PAY_TRADE_LIABILITY_DATA";
export const SAVE_PAY_TRADE_LIABILITY_DATA = "SAVE_PAY_TRADE_LIABILITY_DATA";

export const GET_PAY_OTHER_DEBT_DATA = "GET_PAY_OTHER_DEBT_DATA";
export const SAVE_PAY_OTHER_DEBT_DATA = "SAVE_PAY_OTHER_DEBT_DATA";

export const GET_BUY_ASSET_DATA = "GET_BUY_ASSET_DATA";
export const SAVE_BUY_ASSET_DATA = "SAVE_BUY_ASSET_DATA";

export const GET_PAYMENT_ACCOUNT_DATA = "GET_PAYMENT_ACCOUNT_DATA";
export const SAVE_PAYMENT_ACCOUNT_DATA = "SAVE_PAYMENT_ACCOUNT_DATA";

export const GET_ADD_ASSET_DATA = "GET_ADD_ASSET_DATA";
export const SAVE_ADD_ASSET_DATA = "SAVE_ADD_ASSET_DATA";
export const POST_ADD_ASSET_DATA = "POST_ADD_ASSET_DATA";
export const POST_DELETE_ADD_ASSET_DATA = "POST_DELETE_ADD_ASSET_DATA";

export const GET_AP_LIABILITY_DATA = "GET_AP_LIABILITY_DATA";
export const SAVE_AP_LIABILITY_DATA = "SAVE_AP_LIABILITY_DATA";

export const GET_VIEW_PAYMENT_DATA = "GET_VIEW_PAYMENT_DATA";
export const SAVE_VIEW_PAYMENT_DATA = "SAVE_VIEW_PAYMENT_DATA";

export const GET_EDIT_PAYMENT_DATA = "GET_EDIT_PAYMENT_DATA";
export const SAVE_EDIT_PAYMENT_DATA = "SAVE_EDIT_PAYMENT_DATA";
export const POST_EDIT_PAYMENT_DATA = "POST_EDIT_PAYMENT_DATA";

export const GET_PENDING_PAYMENTS_DATA = "GET_PENDING_PAYMENTS_DATA";
export const SAVE_PENDING_PAYMENTS_DATA = "SAVE_PENDING_PAYMENTS_DATA";

export const GET_APPROVED_PAYMENTS_DATA = "GET_APPROVED_PAYMENTS_DATA";
export const SAVE_APPROVED_PAYMENTS_DATA = "SAVE_APPROVED_PAYMENTS_DATA";
export const POST_APPROVED_PAYMENTS_DATA = "POST_APPROVED_PAYMENTS_DATA";

export const GET_SUBMITTED_PAYMENTS_DATA = "GET_SUBMITTED_PAYMENTS_DATA";
export const SAVE_SUBMITTED_PAYMENTS_DATA = "SAVE_SUBMITTED_PAYMENTS_DATA";

export const GET_REJECTED_PAYMENTS_DATA = "GET_REJECTED_PAYMENTS_DATA";
export const SAVE_REJECTED_PAYMENTS_DATA = "SAVE_REJECTED_PAYMENTS_DATA";

// Order Invoice
export const SAVE_ORDER_INVOICES_VALUE = "SAVE_ORDER_INVOICES_VALUE";

export const GET_CUSTOMERS_DATA = "GET_CUSTOMERS_DATA";
export const GET_DOWNLOAD_CUSTOMERS_DATA = "GET_DOWNLOAD_CUSTOMERS_DATA";
export const GET_CUSTOMERS_FORM_OPTIONS = "GET_CUSTOMERS_FORM_OPTIONS";
export const GET_CUSTOMERS_FORM_CONTACT_STATES =
  "GET_CUSTOMERS_FORM_CONTACT_STATES";
export const GET_CUSTOMERS_FORM_BILLING_STATES =
  "GET_CUSTOMERS_FORM_BILLING_STATES";
export const POST_CUSTOMERS_DATA = "POST_CUSTOMERS_DATA";
export const POST_CUSTOMER_FILE = "POST_CUSTOMER_FILE";
export const GET_CUSTOMER_EDIT_DATA = "GET_CUSTOMER_EDIT_DATA";
export const POST_CUSTOMER_EDIT_DATA = "POST_CUSTOMER_EDIT_DATA";

// payees
export const GET_PAYEE_LIST = "GET_PAYEE_LIST";
export const GET_DOWNLOAD_PAYEE_LIST = "GET_DOWNLOAD_PAYEE_LIST";
export const POST_UPLOAD_PAYEE_LIST = "POST_UPLOAD_PAYEE_LIST";
export const GET_ADD_PAYEE_DATA = "GET_ADD_PAYEE_DATA";
export const POST_ADD_PAYEE_DATA = "POST_ADD_PAYEE_DATA";
export const GET_PAYEE_LINKED_EMPLOYEE = "GET_PAYEE_LINKED_EMPLOYEE";
export const GET_PAYEE_EXPENSE_ACCOUNT = "GET_PAYEE_EXPENSE_ACCOUNT";
export const GET_PAYEE_CONTACT_STATES = "GET_PAYEE_CONTACT_STATES";
export const GET_PAYEE_BILLING_STATES = "GET_CUSTOMERS_FORM_BILLING_STATES";

export const GET_EDIT_PAYEE_DATA = "GET_EDIT_PAYEE_DATA";
export const POST_EDIT_PAYEE_DATA = "POST_EDIT_PAYEE_DATA";

export const GET_PAYEE_PAYMENT_INFO_OPTIONS = "GET_PAYEE_PAYMENT_INFO_OPTIONS";
export const GET_PAYEE_PAYMENT_INFO_DATA = "GET_PAYEE_PAYMENT_INFO_DATA";
export const POST_PAYEE_PAYMENT_INFO_DATA = "POST_PAYEE_PAYMENT_INFO_DATA";
export const POST_DELETE_PAYEE_PAYMENT_INFO_DATA =
  "POST_DELETE_PAYEE_PAYMENT_INFO_DATA";

export const GET_PAYEE_DOCUMENT_DATA = "GET_PAYEE_DOCUMENT_DATA";
export const POST_PAYEE_DOCUMENT_DATA = "POST_PAYEE_DOCUMENT_DATA";
export const DELETE_PAYEE_DOCUMENT_DATA = "DELETE_PAYEE_DOCUMENT_DATA";

export const GET_PAYEE_BANKING_INFO_DATA = "GET_PAYEE_BANKING_INFO_DATA";
export const POST_PAYEE_BANKING_INFO_DATA = "POST_PAYEE_BANKING_INFO_DATA";
export const DELETE_PAYEE_BANKING_INFO_DATA = "DELETE_PAYEE_BANKING_INFO_DATA";
export const POST_PAYEE_STATUS = "POST_PAYEE_STATUS";

export const ADD_PAYEE_PENDING_APPROVAL_DATA =
  "ADD_PAYEE_PENDING_APPROVAL_DATA";

// ar invoices
export const POST_AR_INVOICES_DATA = "POST_AR_INVOICES_DATA";
export const GET_NEW_AR_INVOICES_OPTIONS = "GET_NEW_AR_INVOICES_OPTIONS";

export const GET_AR_INVOICES_DATA = "GET_AR_INVOICES_DATA";
export const GET_EDIT_AR_INVOICES_DATA = "GET_EDIT_AR_INVOICES_DATA";
export const POST_EDIT_AR_INVOICES_DATA = "POST_EDIT_AR_INVOICES_DATA";

export const GET_OUTSTANDING_AR_INVOICES_DATA =
  "GET_OUTSTANDING_AR_INVOICES_DATA";
export const GET_PAID_AR_INVOICES_DATA = "GET_PAID_AR_INVOICES_DATA";
export const GET_CANCELLED_AR_INVOICES_DATA = "GET_CANCELLED_AR_INVOICES_DATA";

export const POST_CANCEL_AR_INVOICE = "POST_CANCEL_AR_INVOICE";

// finance receivables
export const GET_RECEIVABLES_LIST = "GET_RECEIVABLES_LIST";
export const GET_RECEIVABLE_DETAILS = "GET_RECEIVABLE_DETAILS";
export const POST_RECEIVE_PAYMENTS = "POST_RECEIVE_PAYMENTS";

export const GET_CREDIT_NOTE_LIST = "GET_CREDIT_NOTE_LIST";

// finance payables

export const GET_FINANCE_PAYABLES_OUTSTANDING =
  "GET_FINANCE_PAYABLES_OUTSTANDING";
export const GET_FINANCE_AP_CREDIT_NOTES = "GET_FINANCE_AP_CREDIT_NOTES";
export const GET_AP_CREDIT_NOTES_OPTION = "GET_AP_CREDIT_NOTES_OPTION";
export const GET_AP_CREDIT_NOTES_TAX_PERCENTAGE =
  "GET_AP_CREDIT_NOTES_TAX_PERCENTAGE";

export const POST_AP_CREDIT_NOTES_DATA = "POST_AP_CREDIT_NOTES_DATA";
export const GET_EDIT_AP_CREDIT_NOTES_DATA = "GET_EDIT_AP_CREDIT_NOTES_DATA";
export const POST_CREDI_NOTES_ATTACHMENT = "POST_CREDI_NOTES_ATTACHMENT";

// finance assets
export const GET_FINANCE_ASSETS = "GET_FINANCE_ASSETS";
export const DOWNLOAD_FINANCE_ASSETS = "DOWNLOAD_FINANCE_ASSETS";

// finance voucher
export const GET_FINANCE_VOUCHERS = "GET_FINANCE_VOUCHERS";
export const GET_FINANCE_VOUCHERS_LIST = "GET_FINANCE_VOUCHERS_LIST";
export const DOWNLOAD_FINANCE_VOUCHER = "DOWNLOAD_FINANCE_VOUCHER";
export const GET_FINANCE_BALANCE_TO_INCOME = "GET_FINANCE_BALANCE_TO_INCOME";
